<template>
  <div class="purchase-daily">

    <el-card shadow="never">

      <div class="advanced-search-wrapper no-print">
        <el-card-title title="订单采购日报"/>
        <el-search
          :form-item-data="formItemData"
          :rules="rules"
          :is-show.sync="isShow"
          :span="12"
          @onSubmitSingle="onSubmitSingle"
          @onSubmitMulti="onSubmitMulti">
          <el-button size="mini" type="primary" icon="icon-ccui-print" @click="handlePrint">打印</el-button>
          <el-button size="mini" type="primary" icon="icon-ccui-export" @click="handlExport">导出</el-button>
        </el-search>
      </div>
      <div id="print-box" class="print-export">
        <el-card-title
          class="no-screen"
          style="width: auto;margin: 0"
          title="订单采购日报"
          content-text="指标单位/人：中交信科/游欢欢 2019.04.01"/>
        <el-table
          :header-cell-style="{background:'#ffffff',color:'#4A4A4A'}"
          :data="tableData"
          :summary-method="getSummaries"
          style="width: 100%"
          row-key="id"
          show-summary
          border
          class="report multi-header">
          <el-table-column
            prop="id"
            label="序号"
            width="50"/>
          <el-table-column
            prop="name"
            label="采购单位"/>
          <el-table-column
            prop="date"
            label="订单日期"
            width="130"
          />
          <el-table-column
            prop="type"
            label="类型"
            width="130"
          />
          <el-table-column
            :label="formLabelAlign.region.join('/')"
            prop="number">
            <el-table-column
              prop="weekCount"
              label="订单数量(个)"/>
            <el-table-column
              prop="weekAmount"
              label="协议金额(元)"
              align="right">
              <template slot-scope="scope">
                <span :data-sum="scope.row.weekAmount">{{ scope.row.weekAmount }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="yearAmount"
              label="采购金额(元)"
              align="right"/>
            <el-table-column
              prop="monthAmount"
              label="利润(元)"
              align="right"/>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
// import { getList } from '@/api/purchase-daily'
import ExcelJS from 'exceljs/dist/es5/exceljs.browser'
import { saveAs } from 'file-saver'

export default {
  name: 'OrderStatistic',
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      clientHeight: 0,
      tableHeight: 0,
      labelPosition: 'right',
      formLabelAlign: {
        providers: ['京东', '震坤行'],
        type: ['企业订单', '个人订单'],
        region: ['电子超市', '工程专区']
      },
      tableData: [],
      selectors: [{
        value: '京东',
        label: '京东'
      }, {
        value: '震坤行',
        label: '震坤行'
      }, {
        value: '天猫',
        label: '天猫'
      }, {
        value: '聚划算',
        label: '聚划算'
      }, {
        value: '天天特价',
        label: '天天特价'
      }, {
        value: '五一特惠',
        label: '五一特惠'
      }],

      isShow: false,
      input: '',
      formItemData: [
        {
          id: '1',
          type: 'input',
          placeHolder: '采购单位',
          name: 'purchaseName',
          label: '采购单位：',
          value: '',
          outputValue: ''
        },
        {
          id: '2',
          type: 'date-range',
          placeHolder: '订单日期',
          name: 'orderDate',
          label: '订单日期：',
          value: [],
          outputValue: ''
        },
        // {
        //   id: '1',
        //   type: 'select',
        //   placeHolder: '合同名称',
        //   name: 'contractName',
        //   label:'合同名称:',
        //   value: '',
        //   outputValue:'',
        //   option:[
        //     {
        //       value: '1',
        //       label: '类型2A'
        //     }, {
        //       value: '2',
        //       label: '类型2B'
        //     }, {
        //       value: '3',
        //       label: '类型2C'
        //     }, {
        //       value: '4',
        //       label: '类型2D'
        //     }, {
        //       value: '5',
        //       label: '类型2E'
        //     }
        //   ]
        // },
        // {
        //   id: '1',
        //   type: 'input',
        //   placeHolder: '合同名称',
        //   name: 'contractName',
        //   label:'合同名称:',
        //   value: '',
        //   outputValue:''
        // },
        // {
        //   id: '1',
        //   type: 'input-tag-date-picker',
        //   placeHolder: '合同名称',
        //   name: 'contractName',
        //   label:'合同名称:',
        //   value: [],
        //   outputValue:''
        // },
        // {
        //   id: '3',
        //   type: 'select',
        //   placeHolder: '请选择',
        //   name: 'type',
        //   label: '类型:',
        //   value: '',
        //   outputValue: '',
        //   option: [
        //     {
        //       value: '1',
        //       label: '个人订单'
        //     }, {
        //       value: '2',
        //       label: '企业订单'
        //     }, {
        //       value: '3',
        //       label: '个人订单/企业订单'
        //     }
        //   ]
        // },
        {
          id: '3',
          type: 'select-multi-create',
          placeHolder: '请选择',
          name: 'type',
          label: '类型：',
          value: '',
          outputValue: '',
          option: [
            {
              value: '个人订单',
              label: '个人订单'
            }, {
              value: '企业订单',
              label: '企业订单'
            }
          ]
        },
        {
          id: '4',
          type: 'select-multi-create',
          placeHolder: '请选择',
          name: 'zone',
          label: '专区：',
          value: '',
          outputValue: '',
          option: [
            {
              value: '电子超市',
              label: '电子超市'
            }, {
              value: '工程专区',
              label: '工程专区'
            }
          ]
        }

      ],
      rules: {
        contractNumXX: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ]
      },
      value: ''
    }
  },
  watch: {
    formLabelAlign: {
      handler(newVul, oldVul) {
        // console.log(newVul)
        this.getList()
      },
      deep: true
    }
  },
  activated() {
    this.getList()
  },
  mounted() {
    this.clientHeight = document.body.clientHeight
    window.onresize = () => {
      return (() => {
        this.clientHeight = document.body.clientHeight
        console.log(this.clientHeight)
      })()
    }
  },
  methods: {
    jumpToDetail(row, col, e) {
      console.log('wwwwwwwwwww')
      console.log(row)
      console.log(col)
      console.log(e)
      if (row.id) {
        this.$router.push('/statistic/order/purchaser/order-detail/' + row.id)
      } else {
        this.$message('查看详情请点击有序号的行')
      }
    },
    changHandler() {
      this.getList()
    },
    getSummaries(param) {
      // console.log('-----------')
      // console.log(param)
      // console.log('-----------')
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            // console.log(value)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          // console.log(index)
          if (index === 4) {
            sums[index] = sums[index]
          } else {
            sums[index] = sums[index].toFixed(2)
          }
        } else {
          sums[index] = '————'
        }
      })
      return sums
    },
    getList() {
      this.tableHeight = this.clientHeight - 160 - 68 - 40 - 60 - 36
      const lineHeight = 36
      const pageSize = Math.floor(this.tableHeight / lineHeight)
      // console.log('pageSize')
      // console.log(pageSize)
      this.tableData = []
      const obj = {
        pageNum: this.pageNum,
        pageSize: pageSize,
        isShowLoading: true,
        data: { ...this.formLabelAlign }
      }
      getList(obj).then(res => {
        const arr = res.data.data.list
        // this.addItem(arr)
        this.tableData = arr
        console.log(arr)
      })
    },
    addItem(arr) {
      if (arr.length < 10) {
        arr.push({})
        this.addItem(arr)
      }
    },
    async saveAsExcel() {
      const wb = new ExcelJS.Workbook()
      const ws1 = wb.addWorksheet('订单采购日报')
      ws1.getRow(1).values = ['序号', '采购单位', '订单日期', '类型', '电子超市/工程专区', '', '', '']
      ws1.getRow(2).values = ['', '', '', '', '订单个数', '协议金额（元）', '采购金额（元）', '利润（元）']
      ws1.mergeCells('A1:A2')
      ws1.mergeCells('B1:B2')
      ws1.mergeCells('C1:C2')
      ws1.mergeCells('D1:D2')
      ws1.mergeCells('E1:H1')

      ws1.columns = [
        { key: 'id', width: 30 },
        { key: 'name', width: 30 },
        { key: 'date', width: 30 },
        { key: 'type', width: 30 },
        { key: 'weekCount', width: 30 },
        { key: 'weekAmount', width: 30 },
        { key: 'yearAmount', width: 30 },
        { key: 'monthAmount', width: 30 }
      ]

      // const page1Row1 = ws1.addRow(['a', 'b', 'c'])
      // console.log('page1Row1')
      // console.log(page1Row1)
      // page1Row1.font = { bold: true, color: { argb: '00489A' } }
      // page1Row1.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: 'FFFF00' }
      // }

      this.tableData.forEach(row => {
        ws1.addRow([row.id, row.name, row.date, row.type, row.weekCount, row.weekAmount, row.yearAmount, row.monthAmount])
      })

      const row = ws1.getRow(1)
      row.eachCell((cell, rowNumber) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center' }
        cell.font = { size: 13, bold: true, family: 3 }
      })

      const borderStyles = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
      // ws1.eachRow({ includeEmpty: true }, function(row, rowNumber) {
      //   row.border = borderStyles;
      // });

      ws1.eachRow({ includeEmpty: true }, function(row, rowNumber) {
        row.eachCell({ includeEmpty: true }, function(cell, colNumber) {
          cell.border = borderStyles
        })
      })

      const ws2 = wb.addWorksheet('交建第二页')
      const page2Row1 = ws2.addRow(['a', 'b', 'c'])
      page2Row1.font = { bold: true, color: { argb: 'FFF000' }}
      const buf = await wb.xlsx.writeBuffer()
      saveAs(new Blob([buf]), '订单采购日报.xlsx')
    },
    onSubmitMulti(obj) {
      console.log('多字段查询')
      console.log(obj)
      this.changHandler()
    },
    onSubmitSingle(obj) {
      console.log('单字段查询')
      console.log(obj)
      this.changHandler()
    },
    handlePrint() {
      window.print()
    },
    handlExport(value) {
      this.saveAsExcel()
    }
  }
}
</script>

<style lang="scss" scoped>
  .purchase-daily {
    min-height: calc(100vh - 160px);

    /deep/ .el-card__body {
      min-height: calc(100vh - 160px);
    }

    .advanced-search-wrapper {
      position: relative;
      margin-bottom: 20px;

      .el-card-title {
        position: absolute;
        top: -10px;
        left: -20px;
      }
    }

    .el-form-item {
      margin-bottom: 0;
    }

    /deep/ td:nth-child(1) {
      /*font-weight: 600;*/
      color: rgba(74, 74, 74, 1);
    }

    /deep/ .el-table__footer-wrapper {
      td:nth-child(2), td:nth-child(3), td:nth-child(4) {
        text-align: center;
        color: rgba(241, 241, 241, 1);
      }
    }

    /deep/ .el-table th > .cell {
      text-align: left;
    }
  }

  @media print {
    .purchase-daily {
      /deep/ .el-card {
        border: 0;
        padding: 0;
        /*padding: 20px;*/
        .el-card__body {
        }
      }
    }
  }
</style>

